import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unplugged',
  templateUrl: './unplugged.component.html',
  styleUrls: ['./unplugged.component.scss'],
})
export class UnpluggedComponent implements OnInit {
  modulesText = {
    text: 'I concetti di coding vengono illustrati dall’educatore agli alunni attraverso attività analogiche come, per esempio, la pixel art, utilizzando la carta e i colori. L’apprendimento delle basi dell’informatica viene stimolato grazie all’esperienza del gioco di gruppo, (giochi da tavolo o legati all’attività motoria) con semplici attività di logica.',
  };

  constructor() {}

  ngOnInit(): void {}
}
